var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-table",
        {
          attrs: {
            data: _vm.tableData,
            "header-cell-style": {
              color: "#000000",
              fontFamily: "Satoshi-Medium !important",
              fontSize: "14px"
            },
            stripe: "",
            border: ""
          }
        },
        [
          _c("el-table-column", {
            attrs: { width: "350", label: "Store Name" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.storeName
                      ? _c(
                          "span",
                          {
                            staticClass: "store-name",
                            on: {
                              click: function($event) {
                                return _vm.openReport(scope.row)
                              }
                            }
                          },
                          [_vm._v(_vm._s(scope.row.storeName))]
                        )
                      : _c("span", { staticClass: "store-name-na" }, [
                          _vm._v("N/A")
                        ])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "productName", label: "Added to Cart Product" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.productName
                      ? _c(
                          "span",
                          {
                            staticClass: "store-name",
                            on: {
                              click: function($event) {
                                return _vm.openProductDetail(scope.row)
                              }
                            }
                          },
                          [_vm._v(_vm._s(scope.row.productName))]
                        )
                      : _c("span", { staticClass: "store-name-na" }, [
                          _vm._v("N/A")
                        ])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "addToCartTime",
              label: "Add to Cart Time",
              width: "150"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "quantity", label: "Quantity", width: "100" }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("Pagination", {
        attrs: {
          currentPage: _vm.query.pageNo,
          total: _vm.total,
          pageSize: _vm.query.pageSize
        },
        on: {
          handleSizeChange: _vm.handleSizeChange,
          handleCurrentChange: _vm.handleCurrentChange
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c29ad0b0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c29ad0b0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/store-based-marketing/store-based-marketing-detail/add-to-cart.vue
// module id = ebyA
// module chunks = 2